import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignDesignOutputValidation } from '../Product.hooks';
import {
  ProductValidation,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignValidationDialog from './AssignValidationDialog';

export type DesignOutputAssignValidationDialogProps =
  BaseProductAssignDialogProps<'designOutputId'>;

const DesignOutputAssignValidationDialog: React.FC<DesignOutputAssignValidationDialogProps> =
  (props: DesignOutputAssignValidationDialogProps) => {
    const {
      open,
      productId,
      designOutputId,
      selectedItems,
      onCancel,
      onError,
      onAssigned
    } = props;
    const {
      updatedProductDesignOutput,
      isAssigning,
      error: assignError,
      assignValidations
    } = useAssignDesignOutputValidation(productId, designOutputId);

    useEffect(() => {
      if (updatedProductDesignOutput) {
        onAssigned?.(updatedProductDesignOutput);
      }
    }, [updatedProductDesignOutput]);

    useEffect(() => {
      if (assignError) {
        onError?.(assignError);
      }
    }, [assignError]);

    return (
      <AssignValidationDialog
        {...{ open, productId, selectedItems, onCancel, onError }}
        isLoading={isAssigning}
        contentText={`Search for ${getProductEntityName(
          'validation'
        )} to assign to the ${getProductEntityName('designOutput')}.`}
        onSubmit={(validations: ProductValidation[]) => {
          assignValidations({
            validationIds: validations.map(
              (validation: ProductValidation) => validation.id
            )
          });
        }}
      />
    );
  };

export default DesignOutputAssignValidationDialog;
